module.exports = __webpack_public_path__ + "img/FB.ed43abe5.svg";